var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabyKid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C10.8784 2 9.79993 2.18465 8.79332 2.52521C8.89345 3.16369 9.17874 3.95321 9.76752 4.63467C10.5089 5.4927 11.7919 6.25 14 6.25C14.4142 6.25 14.75 6.58579 14.75 7C14.75 7.41421 14.4142 7.75 14 7.75C11.4081 7.75 9.69114 6.84063 8.63248 5.61533C7.94772 4.82279 7.56396 3.92771 7.38261 3.12752C4.18387 4.79561 2 8.14277 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM7.57768 14.3802C7.91999 14.147 8.38656 14.2354 8.6198 14.5777C9.2878 15.5581 10.5343 16.25 12 16.25C13.4657 16.25 14.7122 15.5581 15.3802 14.5777C15.6134 14.2354 16.08 14.147 16.4223 14.3802C16.7646 14.6134 16.853 15.08 16.6198 15.4223C15.6546 16.8389 13.9294 17.75 12 17.75C10.0706 17.75 8.3454 16.8389 7.3802 15.4223C7.14696 15.08 7.23538 14.6134 7.57768 14.3802ZM16.5 12C15.6716 12 15 11.3284 15 10.5C15 9.67157 15.6716 9 16.5 9C17.3284 9 18 9.67157 18 10.5C18 11.3284 17.3284 12 16.5 12ZM9 10.5C9 11.3284 8.32843 12 7.5 12C6.67157 12 6 11.3284 6 10.5C6 9.67157 6.67157 9 7.5 9C8.32843 9 9 9.67157 9 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyKid);
export default __webpack_public_path__ + "static/media/baby-kid.e9d6acc320e8ecd637e5b1ce39ac16f8.svg";
export { ForwardRef as ReactComponent };